if (!customElements.get('collection-filters-custom')) {
  class CollectionFiltersAbstract extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.documentClickHandler = this.documentClick.bind(this);
      this.ajax = true;

      if (this.dataset.open) {
        this.showFilters();
      }

      if (this.pageManager) {
        this.openFilters = this.pageManager.querySelector('.open-filters');
        if (this.openFilters) {
          this.openFilters.addEventListener('click', () => {
            this.showFilters();
          });
        }
      }

      this.closeFilters = this.querySelector('.close-filters');
      if (this.closeFilters) {
        this.closeFilters.addEventListener('click', () => {
          this.hideFilters();
        });
      }
    }

    documentClick(e) {
      if (!this.contains(e.target)) {
        this.hideFilters();
      }
    }

    isOpen() {
      return this.classList.contains('open');
    }

    showFilters() {
      $s.closeModal();
      $s.showOverlay();
      this.classList.add('open');
      $s.trapFocus(this);
    }

    hideFilters() {
      $s.hideOverlay();
      this.classList.remove('open');
      $s.removeTrapFocus();
    }
  }


  class CollectionFilters extends CollectionFiltersAbstract {
    constructor() {
      super();

      this.hideFilter = document.querySelector('.hide-filter');
      if (this.hideFilter) {
        this.hideFilter.addEventListener('click', () => {
          this.hideFilter();
        });
      }

      this.panel = document.querySelector('.collection-sort .links');
      this.sortButton = document.querySelector('.collection-sort .trigger');
      this.documentOnClick = this.documentOnClickHandler.bind(this);

      if (this.sortButton) {
        this.sortButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (this.sortButton.classList.contains('active')) {
            this.hideDropdown();
          } else {
            this.showDropdown();
          }
        });
      }
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.documentOnClick);
    }

    hideFilter() {
      this.classList.toggle('filter-hidden');
      document.querySelector('.collection-grid').classList.toggle('filter-hidden');
    }

    showDropdown() {
      this.sortButton.classList.add('active');
      this.sortButton.setAttribute('aria-expanded', 'true');
      $s.expand([this.panel]);
      $s.trapFocus(this, this.sortButton);
      document.addEventListener('click', this.documentOnClick);
    }

    hideDropdown() {
      this.sortButton.classList.remove('active');
      this.sortButton.setAttribute('aria-expanded', 'false');
      $s.collapse([this.panel]);
      $s.removeTrapFocus();
      document.removeEventListener('click', this.documentOnClick);
    }

    documentOnClickHandler(e) {
      if (!this.contains(e.target)) {
        this.hideDropdown();
      }
    }
  }
  customElements.define('collection-filters-custom', CollectionFilters);

}
